import { AuditLogTable } from "@/components/audit/AuditLogTable";
import { PageHeader } from "@/components/shared/page-header";

export function AuditLogPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="User Action - Audit Log"
        description="Track create, update, and delete activity across the workspace."
      />
      <AuditLogTable />
    </div>
  );
}
